import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  CardImg,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";
import { Redirect } from "react-router-dom";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";

///  <NUEVO PARA NOTIFICAR SIM>
import SweetAlert from "react-bootstrap-sweetalert";
///  </NUEVO PARA NOTIFICAR SIM>
import Iframe from "react-iframe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLastfmSquare } from "@fortawesome/free-brands-svg-icons";
import Fullscreen from "react-full-screen";

// Imagenes APPS
import splashIcon from "assets/img/apps/splash.png";
import _2048Icon from "assets/img/apps/2048.png";
import superOnionBoyIcon from "assets/img/apps/superonionboy.png";
import miniSwitcherIcon from "assets/img/apps/miniswitcher.png";
import chessIcon from "assets/img/apps/chess.png";
import farming10x10Icon from "assets/img/apps/farming10x10.png";
import sicarioKidIcon from "assets/img/apps/sicariokid.png";
import solitarioIcon from "assets/img/apps/solitario.png";
import socxelIcon from "assets/img/apps/socxel.png";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const CONFIRMAR_SIM = "SIM";
class Apps extends React.Component {
  constructor(props) {
    super(props);
    /* //// console.log("########## PROPS ###########");
    //// console.log(props); */
    this.state = {
      servicesSize: 3,
      servicesSmallSize: 6,
      ordersChartReady: false,
      ordersToDisplayInChart: 6,
      fieldStates: [],
      ICC: "",
      confirmICC: "", //ICC del envío
      fieldsToValidateSIMDelivery: ["ICC"],
      confirmingDelivery: "",
      currentApn: "",
      currentCompartir: "",
      isFull: Object.keys(this.props.match.params) > 0
    };

    this.createMobileCards = this.createMobileCards.bind(this);
    this.addSize = this.addSize.bind(this);
    this.subSize = this.subSize.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateSIMDelivery = this.validateSIMDelivery.bind(this);
    this.createConfirmSIMDeliveryPopUp = this.createConfirmSIMDeliveryPopUp.bind(this);
    this.showPopUpConfirmation = this.showPopUpConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.createCurrentTools = this.createCurrentApps.bind(this);
    this.isToolSelected = this.isAppSelected.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
    // // console.log("###### APPS PREV PROPS ######");
    // // console.log(this.prevProps);
    // // console.log("###### APPS PROPS ######");
    // // console.log(this.props);
    // if ((Object.keys(this.props.match.params) > 0) && (Object.keys(this.prevProps.match.params) == 0)) {
    //   this.setState({
    //     isFull: true
    //   });
    // }
    // if (!this.state.isFull && this.prevState.isFull && (Object.keys(this.props.match.params) > 0)) {
    //   this.setState({
    //     toApps: true
    //   });
    // }
    // if (this.state.toApps === true && (Object.keys(this.props.match.params) == 0)) {
    //   this.setState({
    //     toApps: false
    //   });
    // }
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  validateICC(icc) {
    return icc === this.state.confirmICC.substring(this.state.confirmICC.length - 4);
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    switch (field) {
      case "phoneNumber":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "ICC":
        if (this.validateICC(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "iban":
        if (this.validateIBAN(value)) {
          fieldStates[field] = "has-success";
          if (this.isNewIBAN(value)) {
            this.props.setCustomerIBAN(this.state.customer.id, value);
            this.setState({ latestValidatedIBAN: value.replace(/ /g, "") });
          }
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  showPopUp(tipo) {
    // // console.log("######### OPCIONES ###########");
    // // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      confirmICC: "",
      ICC: "",
      confirmingDelivery: "",
      fieldStates: []
    });
  }
  validateSIMDelivery() {
    let validation = true;
    this.state.fieldsToValidateSIMDelivery.map((item,key) => 
    {
      this.validateField(item, this.state[item]);
      if (this.state.fieldStates[item] === "has-danger") validation = false;
      if (!this.state[item] || this.state[item] === "") {
        validation = false;
      }
    });
    return validation;
  }
  deliverySIMConfirmation() {
    if (!this.validateSIMDelivery()) {
      return;
    }
    this.props.confirmSIMDelivery(this.state.confirmingDelivery);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block"/*, marginTop: "-250px" */}}
          title="¡Recepción confirmada!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          Hemos lanzado tu portabilidad, en 36-48h hábiles (sin contar festivos ni fines de semana) estará lista.
        </SweetAlert>
      )
    });
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case CONFIRMAR_SIM:
        this.deliverySIMConfirmation();
        break;
      default:;
    }
  }
  createPopUp() {
    // // console.log("############# CREATING POPUP #############");
    // // console.log(this.state);
    // // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case CONFIRMAR_SIM:
        return this.createConfirmSIMDeliveryPopUp();
      default:
        //// console.log("################## ERROR CREATE POPUP ################");
        //// console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  createConfirmSIMDeliveryPopUp() {
    return (
      <SweetAlert
        style={{ display: "block"/*, marginTop: "-250px"*/ }}
        title="Confirmar SIM"
        onConfirm={() => this.showPopUpConfirmation(CONFIRMAR_SIM)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Confirmar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row className="text-center">
            <div style={{margin: "0 2em 1em 2em", textAlign: "justify"}}>
              <span>Para confirmar la recepción de la SIM, escribe los 4 últimos números de la ICC de la SIM (Los 4 últimos números del código de barras)</span>
            </div> 
            <Col xs={12} md={9}>
              <FormGroup className={this.state.fieldStates["ICC"]}>
                <Input
                  type="number"
                  value={this.state.ICC}
                  onChange={event => {
                    this.setState({ ICC: event.target.value.replace(/\s+/g, '') });
                    this.validateField("ICC", event.target.value.replace(/\s+/g, ''));
                  }}
              />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{
      partialOrders = this.props.mainState.orders.slice(0).reverse();
    }

    partialOrders.map((currentOrder, key) =>{
      ordersChartDates.push(
        moment(currentOrder.fecha, "YYYY/MM/DD").format(
          "MMM YYYY"
        ) /* 
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        }) 
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")*/
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart
    });
  }
  addSize() {
    this.setState({
      servicesSize: this.state.servicesSize + 1
    });
  }
  subSize() {
    this.setState({
      servicesSize: this.state.servicesSize - 1
    });
  }
  createTableData() {
    var tableRows = [];
    for (var i = 0; i < table_data.length; i++) {
      tableRows.push(
        <tr key={i}>
          <td>
            <div className="flag">
              <img src={table_data[i].flag} alt="us_flag" />
            </div>
          </td>
          <td>{table_data[i].country}</td>
          <td className="text-right">{table_data[i].count}</td>
          <td className="text-right">{table_data[i].percentage}</td>
        </tr>
      );
    }
    return tableRows;
  }
  createMobileCards() {
    let mobileContent = null;
    if(this.props.mainState.hasMobile && this.props.mainState.mobilesLoaded){      
      mobileContent = this.props.mainState.mobiles.map((currentMobile, key) =>{
        return (
          <Col key={currentMobile.mobile} xs={12} md={this.state.servicesSize}>
            <Card className="card-stats card-raised">
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Link to={this.props.mainState.mobilesCDRLoaded ? "/movil/" + currentMobile.mobile : "/movil"}>
                      <Statistics
                        showIcon
                        iconState="primary"
                        icon="tech_mobile"
                        title={currentMobile.mobile.substring(0,3) + " " + currentMobile.mobile.substring(3,6) + " " + currentMobile.mobile.substring(6,9)}
                        subtitle={currentMobile.plan.replace(" (Móvil)", "")}
                      />
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    }else if(this.props.mainState.mobilesLoaded){
      mobileContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="tech_mobile"
                    title="Móviles"
                    subtitle="¡Trae tus móviles!"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }else{
      mobileContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Móviles"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }
    return mobileContent;
  }
  createAppsCards() {
    let appsCards = [];
    let currentParams = this.props.match.params;
    let currentApp = null;
    if (Object.keys(this.props.match.params).length > 0) currentApp = currentParams.app;
    
    let splashCard = 
        <Col key={"splashCard"} xs={this.state.servicesSmallSize} md={this.state.servicesSize}>
          <Link to="/apps/splash"> 
            <Card className="text-center card-plain">
              <CardHeader className="card-header-avatar">
                <img width="128px" className="img img-raised" src={splashIcon} alt="Splash App" />
              </CardHeader>
              {/* <CardImg top width="128px" src={splashIcon}alt="Splash App" /> */}
              <CardBody style={{color:"black"}}>
                <CardTitle>Splash</CardTitle>
                {/* <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText> */}
                {/* <Button>Abrir</Button> */}
              </CardBody>
            </Card>
          </Link>
        </Col>;
    appsCards.push(splashCard);

    let _2048Card = 
        <Col key={"2048Card"} xs={this.state.servicesSmallSize} md={this.state.servicesSize}>
          <Link to="/apps/2048"> 
            <Card className="text-center card-plain">
              <CardHeader className="card-header-avatar">
                <img width="128px" className="img img-raised" src={_2048Icon} alt="2048 App" />
              </CardHeader>
              {/* <CardImg top width="128px" src={splashIcon}alt="Splash App" /> */}
              <CardBody>
                <CardTitle style={{color:"black"}}>2048</CardTitle>
                {/* <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText> */}
                {/* <Button>Abrir</Button> */}
              </CardBody>
            </Card>
          </Link>
        </Col>;
    appsCards.push(_2048Card);

    let superOnionCard = 
        <Col key={"superOnionCard"} xs={this.state.servicesSmallSize} md={this.state.servicesSize}>
          <Link to="/apps/superonionboy"> 
            <Card className="text-center card-plain">
              <CardHeader className="card-header-avatar">
                <img width="128px" className="img img-raised" src={superOnionBoyIcon} alt="Super Onion Boy App" />
              </CardHeader>
              {/* <CardImg top width="128px" src={splashIcon}alt="Splash App" /> */}
              <CardBody>
                <CardTitle style={{color:"black"}}>Super Onion Boy</CardTitle>
                {/* <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText> */}
                {/* <Button>Abrir</Button> */}
              </CardBody>
            </Card>
          </Link>
        </Col>;
    appsCards.push(superOnionCard);

    let miniSwitcherCard = 
        <Col key={"miniSwitcherCard"} xs={this.state.servicesSmallSize} md={this.state.servicesSize}>
          <Link to="/apps/miniswitcher"> 
            <Card className="text-center card-plain">
              <CardHeader className="card-header-avatar">
                <img width="128px" className="img img-raised" src={miniSwitcherIcon} alt="Mini Switcher App" />
              </CardHeader>
              {/* <CardImg top width="128px" src={splashIcon}alt="Splash App" /> */}
              <CardBody>
                <CardTitle style={{color:"black"}}>Mini Switcher</CardTitle>
                {/* <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText> */}
                {/* <Button>Abrir</Button> */}
              </CardBody>
            </Card>
          </Link>
        </Col>;
    appsCards.push(miniSwitcherCard);

    let chessCard = 
        <Col key={"chessCard"} xs={this.state.servicesSmallSize} md={this.state.servicesSize}>
          <Link to="/apps/ajedrez"> 
            <Card className="text-center card-plain">
              <CardHeader className="card-header-avatar">
                <img width="128px" className="img img-raised" src={chessIcon} alt="Ajedrez App" />
              </CardHeader>
              {/* <CardImg top width="128px" src={splashIcon}alt="Splash App" /> */}
              <CardBody>
                <CardTitle style={{color:"black"}}>Ajedrez</CardTitle>
                {/* <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText> */}
                {/* <Button>Abrir</Button> */}
              </CardBody>
            </Card>
          </Link>
        </Col>;
    appsCards.push(chessCard);

    let farming10x10Card = 
        <Col key={"farming10x10Card"} xs={this.state.servicesSmallSize} md={this.state.servicesSize}>
          <Link to="/apps/farming10x10"> 
            <Card className="text-center card-plain">
              <CardHeader className="card-header-avatar">
                <img width="128px" className="img img-raised" src={farming10x10Icon} alt="Farming 10x10 App" />
              </CardHeader>
              {/* <CardImg top width="128px" src={splashIcon}alt="Splash App" /> */}
              <CardBody>
                <CardTitle style={{color:"black"}}>Farming 10x10</CardTitle>
                {/* <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText> */}
                {/* <Button>Abrir</Button> */}
              </CardBody>
            </Card>
          </Link>
        </Col>;
    appsCards.push(farming10x10Card);

    let sicarioKidCard = 
        <Col key={"sicarioKidCard"} xs={this.state.servicesSmallSize} md={this.state.servicesSize}>
          <Link to="/apps/sicariokid"> 
            <Card className="text-center card-plain">
              <CardHeader className="card-header-avatar">
                <img width="128px" className="img img-raised" src={sicarioKidIcon} alt="Sicario Kid App" />
              </CardHeader>
              {/* <CardImg top width="128px" src={splashIcon}alt="Splash App" /> */}
              <CardBody>
                <CardTitle style={{color:"black"}}>Sicario Kid</CardTitle>
                {/* <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText> */}
                {/* <Button>Abrir</Button> */}
              </CardBody>
            </Card>
          </Link>
        </Col>;
    appsCards.push(sicarioKidCard);

    let solitarioCard = 
        <Col key={"solitarioCard"} xs={this.state.servicesSmallSize} md={this.state.servicesSize}>
          <Link to="/apps/solitario"> 
            <Card className="text-center card-plain">
              <CardHeader className="card-header-avatar">
                <img width="128px" className="img img-raised" src={solitarioIcon} alt="Solitario App" />
              </CardHeader>
              {/* <CardImg top width="128px" src={splashIcon}alt="Splash App" /> */}
              <CardBody>
                <CardTitle style={{color:"black"}}>Solitario</CardTitle>
                {/* <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText> */}
                {/* <Button>Abrir</Button> */}
              </CardBody>
            </Card>
          </Link>
        </Col>;
    appsCards.push(solitarioCard);

    let socxelCard = 
        <Col key={"socxelCard"} xs={this.state.servicesSmallSize} md={this.state.servicesSize}>
          <Link to="/apps/socxel"> 
            <Card className="text-center card-plain">
              <CardHeader className="card-header-avatar">
                <img width="128px" className="img img-raised" src={socxelIcon} alt="Socxel App" />
              </CardHeader>
              {/* <CardImg top width="128px" src={splashIcon}alt="Splash App" /> */}
              <CardBody>
                <CardTitle style={{color:"black"}}>Soxcel</CardTitle>
                {/* <CardSubtitle>Card subtitle</CardSubtitle>
                <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText> */}
                {/* <Button>Abrir</Button> */}
              </CardBody>
            </Card>
          </Link>
        </Col>;
    appsCards.push(socxelCard);

    return appsCards;
  }
  createCurrentApps() {
    let currentParams = this.props.match.params;
    if (!currentParams) return;
    let currentApp = null;
    let iframeToShow = null;

    switch (currentParams.app) {
      case "apn":
        if (this.state.currentApn)
          iframeToShow = 
            <Card>
              <CardBody>
                <Row>
                  <Iframe
                    width="100%"
                    height="900px"
                    frameBorder="0"
                    src={"https://nadunet.es/apn/" + this.state.currentApn + "/api"}
                  />
                </Row>
              </CardBody>
            </Card>;
        currentApp = 
          <div>
            <Card className="card-plain card-subcategories">
              <CardBody>
                <Nav
                  pills
                  className="nav-pills-primary nav-pills-icons justify-content-center"
                >
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "samsung" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "samsung" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon={['fab', 'stripe-s']} size="3x"/>
                        {/* <FontAwesomeIcon icon={['fab', 'apple']}  size="lg"/> */}
                      </div>
                      Samsung
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "xiaomi" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "xiaomi" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon="times" size="3x"/>
                        {/* <FontAwesomeIcon icon={['fab', 'apple']}  size="lg"/> */}
                      </div>
                      Xiaomi
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "huawei" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "huawei" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon="heading" size="3x"/>
                      {/* <FontAwesomeIcon icon={['fab', 'apple']}  size="lg"/> */}
                      </div>
                      Huawei
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "apple" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "apple" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon={['fab', 'apple']}  size="3x"/>
                      </div>
                      Apple
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "otros" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "otros" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon="mobile-alt" size="3x" />
                      </div>
                      Otros Android
                    </NavLink>
                  </NavItem>
                </Nav>
                {/* <TabContent
                  className="tab-space tab-subcategories"
                  activeTab={this.state.currentApn}
                >
                  <TabPane tabId={this.state.currentApn}>
                    Collaboratively administrate empowered markets via
                    plug-and-play networks. Dynamically procrastinate B2C
                    users after installed base benefits.
                    <br />
                    <br />
                    Dramatically visualize customer directed convergence
                    without revolutionary ROI.
                  </TabPane>
                </TabContent> */}
              </CardBody>
            </Card>
            {iframeToShow}
          </div>;
        break;
      case "splash":
        currentApp = "https://paveldogreat.github.io/WebGL-Fluid-Simulation/";
        break;
      case "2048":
        currentApp = "https://wanted5games.com/games/html5/2048-legend-new-en-s-iga-cloud/index.html";
        break;
      case "superonionboy":
        currentApp = "https://wanted5games.com/games/html5/onion-boy-new-en-s-iga-cloud/index.html";
        break;
      case "miniswitcher":
        currentApp = "https://wanted5games.com/games/html5/mini-switcher-new-en-s-iga-cloud/index.html";
        break;
      case "ajedrez":
        currentApp = "https://wanted5games.com/games/html5/chess-new-en-s-iga-cloud/index.html";
        break;
      case "farming10x10":
        currentApp = "https://wanted5games.com/games/html5/10x10-farming-new-en-s-iga-cloud/index.html";
        break;
      case "sicariokid":
        currentApp = "https://wanted5games.com/games/html5/sicario-kid-new-en-s-iga-cloud/index.html";
        break;
      case "solitario":
        currentApp = "https://wanted5games.com/games/html5/socxel-new-en-s-iga-cloud/index.html";
        break;
      case "socxel":
        currentApp = "https://wanted5games.com/games/html5/socxel-new-en-s-iga-cloud/index.html";
        break;
      default:;
    }
    return (
      <Iframe
        width="100%"
        height="100%"
        frameBorder="0"
        src={currentApp}
        className="full-screenable-node"
      />
    );
  }
  isAppSelected() {
    if (this.props.match.params) {
      if (Object.keys(this.props.match.params) > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  goToApps() {
    this.setState({toApps: true});
  }
  render() {
    // // console.log("###### APPS STATE ######");
    // // console.log(this.state);
    // if (this.state.toApps === true) {
    //   return <Redirect to="/apps" />;
    // }
    // // console.log("######## PARAMS TOOLS ##########");
    // // console.log(this.props.match.params);
    let appsCards = this.createAppsCards();
    let currentApp = this.createCurrentApps();
    let _isToolSelected = this.isAppSelected();
    
    if (Object.keys(this.props.match.params) == 0) {
      return (
        <div>
          <PanelHeader
            size="sm"
            content={
              <div>
                {/* <h6 style={dashboardOrdersTitleStyle}>Herramientas</h6> */}
              </div>
            }
          />
          <div className="content">
            {this.state.showPopUp && this.createPopUp()}
            {this.state.popUpConfirmation}
            <Row>
              {appsCards}
              <Col xs={12} md={12}>
                {currentApp}
              </Col>
            </Row>
          </div>
        </div>
      );
    } else {
      return (currentApp);
    }
  }
}

export default Apps;



// WEBPACK FOOTER //
// ./src/views/Apps/Apps.jsx